import {Component, OnInit} from '@angular/core';
import {BottomSliderComponent} from "../bottom-slider/bottom-slider.component";
import {TemplateComponent} from "../../template/template.component";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-home-slider',
    standalone: true,
    imports: [
        BottomSliderComponent,
        NgIf
    ],
    templateUrl: './home-slider.component.html',
    styleUrl: './home-slider.component.css'
})
export class HomeSliderComponent extends TemplateComponent implements OnInit {
    title_section: any = {};
    performanc: any;

    ngOnInit() {
        if (this.global.getMainData()['main-page']!= null) {
            this.title_section = JSON.parse(this.global.getMainData()['main-page']['data'])['title-section'];
            this.performanc = JSON.parse(this.global.getMainData()['main-page']['data'])['performance-bar'];
            setTimeout(() => {
                this.title_section = JSON.parse(this.global.getMainData()['main-page']['data'])['title-section'];
                this.performanc = JSON.parse(this.global.getMainData()['main-page']['data'])['performance-bar'];
            }, 1000)
        }

    }

}
